<template>
  <div class="flex">
    <div class="w-2/3">
      <section>
        <ContentSectionLoader v-show="loading" />
        <transition name="fade">
          <div
            v-if="!loading"
            class="table-responsive mt-0"
          >
            <table class="table w-full table-data min-w-table overflow-hidden">
              <thead>
                <tr>
                  <th v-text="'Type'" />
                  <th v-text="'Amount'" />
                  <th v-text="'Date'" />
                  <th
                    class="text-center"
                    v-text="'Invoice'"
                  />
                  <th v-text="'Status'" />
                  <th v-text="'Next Payment'" />
                  <th
                    v-can="'manage-refunds'"
                    v-text="'Refund'"
                  />
                </tr>
              </thead>
              <tbody v-if="payments.data.length">
                <tr
                  is="Row"
                  v-for="payment in payments.data"
                  :key="payment.uuid"
                  :payment="payment"
                  @refreshPayments="refreshPayments"
                  hide-payer
                />
              </tbody>
              <tbody v-else>
                <tr>
                  <td
                    class="text-center"
                    colspan="100"
                    v-text="'No results'"
                  />
                </tr>
              </tbody>
            </table>
            <Pagination
              :on-change="updatePage"
              :pagination="pagination"
            />
          </div>
        </transition>
      </section>
    </div>
    <MembershipPaymentInfo :membership-uuid="membershipUuid" />
  </div>
</template>

<script type="text/babel">

import { mapActions, mapState } from 'vuex'
import Row from './PaymentRow'
import MembershipPaymentInfo from './MembershipPaymentInfo'
import Pagination from 'Base/Resources/assets/js/components/Pagination'

export default {
  name: 'MembershipPayments',
  components: {
    Row,
    Pagination,
    MembershipPaymentInfo,
  },
  props: {
    membershipUuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    ...mapState({
      payments: state => state.payments.payments,
    }),
    pagination() {
      return this.payments.meta.pagination
    },
  },
  mounted() {
    this.fetchPayments()
  },
  methods: {
    ...mapActions([
      'paymentsGetPayments',
    ]),
    updatePage(page) {
      this.fetchPayments(page)
    },
    fetchPayments(page = 1) {
      this.loading = true

      this.paymentsGetPayments({
        membership: this.membershipUuid,
        page: page,
        include: 'payer.subscription,refund,chargeable',
      }).then(() => {
        this.loading = false
      })
    },
    refreshPayments() {
      this.fetchPayments(this.pagination.current_page)
    },
  },
}
</script>
